import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';
import {
    Avatar, Box, Button, Container, TextField, Typography
} from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import Copyright from 'components/common/Copyright';
import useAuth from 'hooks/useAuth';


const InvitePasswordMake = () => {
    const {t} = useTranslation();
    const {finishInvite} = useAuth();
    const {token} = useParams();
    const [email] = useQueryParam('email', StringParam);
    const passRef = useRef<HTMLInputElement>(null);
    const pass2Ref = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        finishInvite(
            email || '',
            data.get('password') as string,
            data.get('password_confirmation') as string,
            token as string,
        )
            .then(() => navigate('/login', {replace: true}))
            .catch(() => {
                passRef.current!.value = '';
                pass2Ref.current!.value = '';
            })
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Avatar sx={{m: 1, bgcolor: 'secondary.main'}}>
                    <LockOutlined/>
                </Avatar>
                <Typography component="h1" variant="h5">
                    {t('make_password')}
                </Typography>
                <Box component="form" onSubmit={submit} sx={{mt: 1}}>
                    <TextField
                        margin="normal"
                        required
                        type="email"
                        fullWidth
                        id="email"
                        label={t('email_address')}
                        name="email"
                        autoComplete="email"
                        autoFocus
                        defaultValue={email}
                        disabled
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label={t('password')}
                        type="password"
                        id="password"
                        autoComplete="new-password"
                        inputProps={{minLength: 8}}
                        inputRef={passRef}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password_confirmation"
                        label={t('password_confirmation')}
                        type="password"
                        id="password_confirmation"
                        autoComplete="new-password"
                        inputProps={{minLength: 8}}
                        inputRef={pass2Ref}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{mt: 3, mb: 2}}
                    >
                        {t('make_password')}
                    </Button>
                </Box>
            </Box>
            <Copyright sx={{mt: 8, mb: 4}}/>
        </Container>
    );
};

export default InvitePasswordMake;
